import {STATIC_ENVIRONMENT as defaults, StaticEnvironment} from './defaults';

export const STATIC_ENVIRONMENT: StaticEnvironment = {
  ...defaults,
  production: true,
};
